import { render, staticRenderFns } from "./VideosUpgradeSettings.vue?vue&type=template&id=ad0bc164&scoped=true"
import script from "./VideosUpgradeSettings.vue?vue&type=script&lang=js"
export * from "./VideosUpgradeSettings.vue?vue&type=script&lang=js"
import style0 from "./VideosUpgradeSettings.vue?vue&type=style&index=0&id=ad0bc164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0bc164",
  null
  
)

export default component.exports